<template>
  <div class="p-col-12">
    <page-header title="dataTable.text-fragment.title" :actions="pageActions"/>
    <ancestryline-data-table :data-function="dataFunction" :columns="columns"/>
  </div>
</template>

<script>
import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
import FrontBusiness from "@/business/FrontBusiness";
import ToastMessageBusiness from "@/business/ToastMessageBusiness";
import PageHeader from "@/components/page/PageHeader";
import Audit from "@/viewer/user/Audit";
import TextFragmentBusiness from "@/business/TextFragmentBusiness";
import DialogService from "@/business/ModalBusiness";
import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";

export default {
  name: "TextFragmentList",
  components: {PageHeader, AncestrylineDataTable},

  data() {
    return {
      dataFunction: TextFragmentBusiness.pagination,
      columns: [
        {field: "name", header: 'dataTable.text-fragment.columns.name', sortable:true},
        {field: "code", header: 'dataTable.text-fragment.columns.code', sortable:true},
        {field: "fragmentGroup", header: 'dataTable.text-fragment.columns.group', sortable:true},
        {field: "created", header: 'dataTable.text-fragment.columns.created', sortable:true, type: 'date-time'},
        {field: "active", header: 'dataTable.text-fragment.columns.active', sortable:true, type: 'boolean'},
        {field: "actions", header: 'dataTable.actions', sortable:false, type: 'actions', style: 'width: 100px',
          actions: [
            {icon: 'pi pi-pencil', title: 'dataTable.text-fragment.columns.edit', function: this.editTextFragment},
            {icon: 'pi pi-trash', title: 'dataTable.text-fragment.columns.delete', function: this.deleteTypeService, refreshList: true},
          ]
        },
      ],
      pageActions: [
        {icon: 'pi pi-plus', label: 'dataTable.text-fragment.add', url: '/text-fragment'},
        {icon: 'pi pi-eye', label: 'audit.button-list', function: this.openModal, type: 'button'},
      ],
    }
  },

  methods: {

    editTextFragment(textFragment){
      FrontBusiness.redirect(`/text-fragment/${textFragment.id}`);
    },

    async deleteTypeService(textFragment, dataList){
      if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
        const response = await TextFragmentBusiness.delete(textFragment.id).catch((e) => ToastMessageBusiness.showError(e.message));
        if(response){
          dataList = dataList.filter(c => c.id !== textFragment.id);
          ToastMessageBusiness.showSuccess();
        }
        return dataList;
      }
    },

    openModal(){
      DialogService.openModal(Audit, {business: TextFragmentBusiness});
    }

  }

}
</script>

<style scoped>

</style>